<template>
  <div class="h-screen flex w-full bg-img">
    <amio-sidebar :is-deactivated="true" />
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
      <h1 class="mx-0 xs:mx-24 sm:mx-0 text-5xl d-theme-heading-color">Your trial period has ended.</h1>
      <span class="mt-5 xs:mx-32 sm:mx-0 text-xl">Subscribe now to keep building and refining your chatbot with Amio.</span>
      <base-button id="stripe"
                   variant="primary"
                   class="mt-5 text-center w-56 justify-center"
                   external-link="https://buy.stripe.com/bIY5ns97N6tNccU9AA"
                   target="_blank"
      >
        Subscribe to Continue
      </base-button>
    </div>
  </div>
</template>

<script>
import AmioSidebar from '@/components/AmioSidebar'

export default {
  components: {
    AmioSidebar
  }
}
</script>
